import {Grid} from "@mui/material";
import {AppCardTitle, AppCrudTable} from "@components";
import {userSettingSitesGroupData} from "../@signals";
import React from "react";
import {actionsColumn, nameColumn, sitesNameColumn} from "./columns";
import UserSettingSitesGroupDrawer from "./Drawer";
import { isTourDemoActive } from "@signals/app"
import UserSettingSitesGroupTabButton from "./Button"

export default function UserSettingsSitesGroupTab() {
    return <Grid container spacing={1}>
        {(!isTourDemoActive.value || !!userSettingSitesGroupData.value?.length) && <Grid item xs={12}>
            <AppCrudTable
            	// The tab's create button with the table's own actions, as every list of the app
            	options={{ customToolbar: () => <UserSettingSitesGroupTabButton/> }}
                title={<AppCardTitle icon="globe" title="Your Sites Group"/>}
                data={userSettingSitesGroupData.value}
                columns={[
                    nameColumn(),
                    sitesNameColumn(),
                    actionsColumn()
                ]}
            />
        </Grid>}

        <UserSettingSitesGroupDrawer />
    </Grid>
}